import React, { useEffect } from "react";
import {
  Route,
  Routes,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Header from "./components/header.js";
import Announcements from "./containers/announcements/announcements.js";
import Footer from "./components/footer.js";
import PrivateInformation from "./components/PrivateInformation.js";
import MedicalCare from "./containers/hr/benefity/medicalCare.js";
import GroupInsurance from "./containers/hr/benefity/groupInsurance.js";
import Multisport from "./containers/hr/benefity/multisport.js";
import Directives from "./containers/hr/documents/directives.js";
import Instructions from "./containers/hr/documents/instructions.js";
import Prints from "./containers/hr/documents/prints.js";
import Regulations from "./containers/hr/documents/regulations.js";
import PPK from "./containers/hr/documents/ppk.js";
import PPWR from "./containers/hr/documents/ppwr.js";
import Reports from "./containers/hr/documents/reports.js";
import AI from "./containers/hr/ai.js";
import AbsencesMaritex from "./containers/absences/maritex.js";
import AbsencesNiviss from "./containers/absences/niviss.js";
import ContactMaritex from "./containers/contactDatabase/maritex.js";
import ContactNiviss from "./containers/contactDatabase/niviss.js";
import DHLParcel from "./containers/logistics/DHLParcel.js";
import DHL from "./containers/logistics/DHL.js";
import UPS from "./containers/logistics/UPS.js";
import InPost from "./containers/logistics/InPost.js";
import MaritexEvery from "./containers/absences/maritexEvery.js";
import NivissEvery from "./containers/absences/nivissEvery.js";
import Cars from "./containers/reservations/cars.js";
import CarsReservations from "./containers/reservations/carsReservations.js";
import EditCarReservation from "./containers/reservations/editCarReservation.js";
import ConferenceRooms from "./containers/reservations/conferenceRooms.js";
import RoomsReservations from "./containers/reservations/roomsReservations.js";
import EditRoomReservation from "./containers/reservations/editRoomReservation.js";
import RecurringReservations from "./containers/reservations/recurringReservations.js";
import Schedule from "./containers/schedule/schedule.js";
import TODO from "./components/TODO/TODO.js";
import { AuthProvider, useAuth } from "./AuthContext.js";
import AddAnnouncement from "./containers-admin/announcements/addAnnouncements.js";
import EditAnnouncement from "./containers-admin/announcements/editAnnouncements.js";
import AddGroupInsurance from "./containers-admin/hr/benefity/addGroupInsurance.js";
import AddMedicalCare from "./containers-admin/hr/benefity/addMedicalCare.js";
import AddMultisport from "./containers-admin/hr/benefity/addMultisport.js";
import AddDirective from "./containers-admin/hr/documents/addDirective.js";
import AddInstructions from "./containers-admin/hr/documents/addInstructions.js";
import AddPrints from "./containers-admin/hr/documents/addPrints.js";
import AddRegulations from "./containers-admin/hr/documents/addRegulations.js";
import AddPPK from "./containers-admin/hr/documents/addPPK.js";
import AddPPWR from "./containers-admin/hr/documents/addPPWR.js";
import AddReports from "./containers-admin/hr/documents/addReports.js";
import AddAI from "./containers-admin/hr/addAI.js";
import EditDocument from "./components/editDocument.js";
// import ContactMaritexAdmin from "./containers-admin/contactDatabase/maritex.js";
// import ContactNivissAdmin from "./containers-admin/contactDatabase/niviss.js";
import AddMaritexContact from "./containers-admin/contactDatabase/addMaritex.js";
import AddNivissContact from "./containers-admin/contactDatabase/addNiviss.js";
// import AbsencesMaritexAdmin from "./containers-admin/absences/maritex.js";
// import AbsencesNivissAdmin from "./containers-admin/absences/niviss.js";
// import AddAbsencesMaritexAdmin from "./containers-admin/absences/addMaritex.js";
// import AddAbsencesNivissAdmin from "./containers-admin/absences/addNiviss.js";
import ManageCars from "./containers-admin/reservations/manageCars.js";
import AddCar from "./containers-admin/reservations/addCar.js";
import EditCar from "./containers-admin/reservations/editCar.js";
import ManageRooms from "./containers-admin/reservations/manageRooms.js";
import AddRoom from "./containers-admin/reservations/addRoom.js";
import EditRoom from "./containers-admin/reservations/editRoom.js";
import ScheduleAdmin from "./containers-admin/schedule/scheduleAdmin.js";
import { NotificationProvider } from "./components/NotificationContext.js";
import SignalRListener from "./services/SignalRNotification.js";
import privateButton from "./media/private-button.svg";

import "./styleSheet/main/app.css";
import "./styleSheet/main/announcemenets/announcements.css";
import "./styleSheet/main/components/header/header.scss";
import "./styleSheet/main/components/footer/footer.css";
import "./styleSheet/main/components/privateInformation/privateInformation.css";
import "./styleSheet/main/hr/benefity/medicalCare/medicalCare.css";
import "./styleSheet/main/hr/benefity/groupInsurance/groupInsurance.css";
import "./styleSheet/main/hr/benefity/multisport/multisport.css";
import "./styleSheet/main/hr/documents/directives/directives.css";
import "./styleSheet/main/absences/maritex/maritex.css";
import "./styleSheet/main/absences/niviss/niviss.css";
import "./styleSheet/main/components/contactTable/contactTable.css";
import "./styleSheet/main/logistics/DHLParcel/DHLParcel.css";
import "./styleSheet/main/absences/maritexEvery/maritexEvery.css";
import "./styleSheet/main/absences/nivissEvery/nivissEvery.css";
import "./styleSheet/main/reservations/cars/cars.css";
import "./styleSheet/main/reservations/carsReservations/carsReservations.css";
import "./styleSheet/main/reservations/conferenceRooms/conferenceRooms.css";
import "./styleSheet/main/reservations/roomsReservations/roomsReservations.css";
import "./styleSheet/main/reservations/recurringReservations/recurringReservations.css";
import "./styleSheet/main/components/TODO/TODO.css";
import "./styleSheet/main/logistics/DHL/dhl.css";
import "./styleSheet/main/logistics/UPS/ups.css";
import "./styleSheet/main/logistics/InPost/inpost.css";
import "./styleSheet/main/schedule/schedule.scss";

// Dodaję komponent ładowania
export const LoadingComponent = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>Ładowanie...</p>
  </div>
);

// Komponent opakowujący dla animacji
const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        x: 20,
        filter: "blur(4px)",
      }}
      animate={{
        opacity: 1,
        x: 0,
        filter: "blur(0px)",
      }}
      exit={{
        opacity: 0,
        x: -20,
        filter: "blur(4px)",
      }}
      transition={{
        duration: 0.2,
        ease: [0.22, 1, 0.36, 1],
        filter: { duration: 0.15 },
      }}
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100%",
      }}
    >
      {children}
    </motion.div>
  );
};

// Komponent ostrzegawczy o rozmiarze ekranu
const ScreenSizeWarning = () => (
  <div className="screen-size-warning">
    <div className="icon">⚠️</div>
    <h2>Ekran jest zbyt mały</h2>
    <p>
      Aby korzystać z aplikacji, prosimy o powiększenie okna przeglądarki lub
      obrócenie urządzenia. Minimalna szerokość ekranu to 1360px.
    </p>
  </div>
);

function App() {
  const { userData, authenticated } = useAuth();
  const location = useLocation();
  const getRole = () => userData.userRole;
  const isStudentUser = userData.userRoles?.some(
    (role) => role.toLowerCase() === "student",
  );
  const isAdminUser =
    !isStudentUser && (getRole() === "admin" || getRole() === "hr-manager");

  if (!authenticated) {
    return <LoadingComponent />;
  }

  const getDefaultRoute = () => {
    if (getRole() === "admin") return "/administrator/aktualnosci";
    if (getRole() === "hr-manager") return "/administrator/aktualnosci";
    return "/aktualnosci";
  };

  return (
    <NotificationProvider>
      {/* <TODO /> */}
      <SignalRListener />
      <ScreenSizeWarning />
      <div className="App">
        <Header />
        <div className="main-layout">
          <PrivateInformation />
          <div className="main-content">
            <AnimatePresence mode="wait">
              <Routes location={location} key={location.pathname}>
                {/* Strona domyślna zależna od roli użytkownika */}
                <Route
                  path="/"
                  element={
                    <PageTransition>
                      <Navigate to={getDefaultRoute()} />
                    </PageTransition>
                  }
                />

                {/* Aktualności */}
                <Route
                  path="/aktualnosci"
                  element={
                    <PageTransition>
                      {getRole() === "user" ? (
                        <Announcements />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/aktualnosci"
                  element={
                    <PageTransition>
                      <Announcements />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/aktualnosci/nowe-ogloszenie"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddAnnouncement />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/aktualnosci/edytuj/:id"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <EditAnnouncement />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                {/* Dokumenty */}
                <Route
                  path="/pliki/dokumenty/zarzadzenia"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <Directives />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/zarzadzenia"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <Directives />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/zarzadzenia/nowe-zarzadzenie"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddDirective />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/pliki/dokumenty/druki"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <Prints />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/druki"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <Prints />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/druki/nowe-druki"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddPrints />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/pliki/dokumenty/regulaminy"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <Regulations />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/regulaminy"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <Regulations />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/regulaminy/nowe-regulaminy"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddRegulations />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/pliki/dokumenty/instrukcje"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <Instructions />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/instrukcje"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <Instructions />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/instrukcje/nowe-instrukcje"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddInstructions />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/pliki/dokumenty/ppk"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <PPK />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/ppk"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <PPK />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/ppk/nowe-ppk"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddPPK />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/pliki/dokumenty/ppwr"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <PPWR />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/ppwr"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <PPWR />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/ppwr/nowe-ppwr"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddPPWR />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/pliki/dokumenty/raporty"
                  element={
                    <PageTransition>
                      {getRole() === "user" || getRole() === "hr-manager" ? (
                        <Reports />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/raporty"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <Reports />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/dokumenty/raporty/nowe-raporty"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddReports />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/administrator/pliki/dokumenty/:category/edytuj/:id"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <EditDocument />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/benefity/:category/edytuj/:id"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <EditDocument />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/ai/edytuj/:id"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <EditDocument />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                {/* Benefity */}
                <Route
                  path="/pliki/benefity/opieka-medyczna"
                  element={
                    <PageTransition>
                      <MedicalCare />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/benefity/opieka-medyczna"
                  element={
                    <PageTransition>
                      <MedicalCare />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/benefity/opieka-medyczna/nowe-opieka-medyczna"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddMedicalCare />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/pliki/benefity/ubezpieczenie-grupowe"
                  element={
                    <PageTransition>
                      <GroupInsurance />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/benefity/ubezpieczenie-grupowe"
                  element={
                    <PageTransition>
                      <GroupInsurance />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/benefity/ubezpieczenie-grupowe/nowe-ubezpieczenie-grupowe"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddGroupInsurance />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/pliki/benefity/multisport"
                  element={
                    <PageTransition>
                      <Multisport />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/benefity/multisport"
                  element={
                    <PageTransition>
                      <Multisport />
                    </PageTransition>
                  }
                />
                <Route
                  path="/pliki/ai"
                  element={
                    <PageTransition>
                      <AI />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/ai"
                  element={
                    <PageTransition>
                      <AI />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/pliki/ai/nowy-dokument-ai"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddAI />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/administrator/pliki/benefity/multisport/nowe-multisport"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddMultisport />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                {/* Baza teleadresowa */}
                <Route
                  path="/baza-teleadresowa/maritex"
                  element={
                    <PageTransition>
                      <ContactMaritex />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/baza-teleadresowa/maritex"
                  element={
                    <PageTransition>
                      <ContactMaritex />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/baza-teleadresowa/maritex/nowy-pracownik"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <AddMaritexContact />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/baza-teleadresowa/niviss"
                  element={
                    <PageTransition>
                      <ContactNiviss />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/baza-teleadresowa/niviss"
                  element={
                    <PageTransition>
                      <ContactNiviss />
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/baza-teleadresowa/niviss/nowy-pracownik"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <AddNivissContact />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                {/* Nieobecności */}
                <Route
                  path="/nieobecnosci/maritex"
                  element={
                    <PageTransition>
                      <AbsencesMaritex />
                    </PageTransition>
                  }
                />
                {/* <Route
                  path="/administrator/nieobecnosci/maritex/"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AbsencesMaritexAdmin />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                /> */}
                {/* <Route
                  path="/administrator/nieobecnosci/maritex/nowa-nieobecnosc"
                  element={
                    <PageTransition>
                      {getRole() === "admin" || getRole() === "hr-manager" ? (
                        <AddAbsencesMaritexAdmin />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                /> */}
                <Route
                  path="/nieobecnosci/maritex/wszystkie-nieobecnosci"
                  element={
                    <PageTransition>
                      <MaritexEvery />
                    </PageTransition>
                  }
                />
                <Route
                  path="/nieobecnosci/niviss"
                  element={
                    <PageTransition>
                      <AbsencesNiviss />
                    </PageTransition>
                  }
                />
                <Route
                  path="/nieobecnosci/niviss/wszystkie-nieobecnosci"
                  element={
                    <PageTransition>
                      <NivissEvery />
                    </PageTransition>
                  }
                />

                {/* Logistyka */}
                <Route
                  path="/logistyka/uslugi-dhl-parcel"
                  element={
                    <PageTransition>
                      <DHLParcel />
                    </PageTransition>
                  }
                />
                <Route
                  path="/logistyka/dhl"
                  element={
                    <PageTransition>
                      <DHL />
                    </PageTransition>
                  }
                />
                <Route
                  path="/logistyka/ups"
                  element={
                    <PageTransition>
                      <UPS />
                    </PageTransition>
                  }
                />
                <Route
                  path="/logistyka/inpost"
                  element={
                    <PageTransition>
                      <InPost />
                    </PageTransition>
                  }
                />
                <Route
                  path="/logistyka"
                  element={
                    <PageTransition>
                      <DHLParcel />
                    </PageTransition>
                  }
                />

                {/* Rezerwacje */}
                <Route
                  path="/rezerwacje/samochody"
                  element={
                    <PageTransition>
                      <Cars />
                    </PageTransition>
                  }
                />
                <Route
                  path="/rezerwacje/samochody/zarezerwuj"
                  element={
                    <PageTransition>
                      <CarsReservations />
                    </PageTransition>
                  }
                />
                <Route
                  path="/rezerwacje/samochody/edytuj/:id"
                  element={
                    <PageTransition>
                      <EditCarReservation />
                    </PageTransition>
                  }
                />

                {/* Administrator - zarządzanie samochodami */}
                <Route
                  path="/administrator/samochody"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <ManageCars />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/samochody/nowy-samochod"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <AddCar />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/samochody/edytuj/:id"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <EditCar />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/administrator/sale-konferencyjne"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <ManageRooms />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/sale-konferencyjne/nowa-sala"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <AddRoom />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/sale-konferencyjne/edytuj/:id"
                  element={
                    <PageTransition>
                      {getRole() === "admin" ? (
                        <EditRoom />
                      ) : (
                        <LoadingComponent />
                      )}
                    </PageTransition>
                  }
                />

                <Route
                  path="/rezerwacje/sale-konferencyjne"
                  element={
                    <PageTransition>
                      <ConferenceRooms />
                    </PageTransition>
                  }
                />
                <Route
                  path="/rezerwacje/sale-konferencyjne/zarezerwuj"
                  element={
                    <PageTransition>
                      <RoomsReservations />
                    </PageTransition>
                  }
                />
                <Route
                  path="/rezerwacje/sale-konferencyjne/edytuj/:id"
                  element={
                    <PageTransition>
                      <EditRoomReservation />
                    </PageTransition>
                  }
                />
                <Route
                  path="/rezerwacje/sale-konferencyjne/zarezerwuj/cyklicznie"
                  element={
                    <PageTransition>
                      <RecurringReservations />
                    </PageTransition>
                  }
                />

                {/* Harmonogram */}
                <Route
                  path="/harmonogram"
                  element={
                    <PageTransition>
                      {getRole() === "user" || isStudentUser ? (
                        <Schedule />
                      ) : (
                        <Navigate to="/aktualnosci" replace />
                      )}
                    </PageTransition>
                  }
                />
                <Route
                  path="/administrator/harmonogram"
                  element={
                    <PageTransition>
                      {isStudentUser ? (
                        <Navigate to="/harmonogram" replace />
                      ) : isAdminUser ? (
                        <ScheduleAdmin />
                      ) : (
                        <Navigate to="/aktualnosci" replace />
                      )}
                    </PageTransition>
                  }
                />
              </Routes>
            </AnimatePresence>
          </div>
        </div>
        <Footer />
        <TODO />
      </div>
    </NotificationProvider>
  );
}

export default App;
